import { render } from "./AppWebName.vue?vue&type=template&id=1c00bf30&scoped=true&ts=true&lang=pug"
import script from "./AppWebName.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppWebName.vue?vue&type=script&lang=ts&setup=true"

import "./AppWebName.vue?vue&type=style&index=0&id=1c00bf30&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c00bf30"]])

export default __exports__